<template>
  <header class="header">
    <button class="hamburger" @click="toggleMenu">☰</button>
    <a href="/" class="logo">Polly Dugan</a>
    <nav class="navbar">
      <router-link to="/" class="nav-link" @click="handleNavClick"
        >Home</router-link
      >
      <nav-dropdown @close-menu="closeMenu" />
      <router-link to="/features" class="nav-link" @click="handleNavClick"
        >Events</router-link
      >
      <router-link to="/contact" class="nav-link" @click="handleNavClick"
        >Contact</router-link
      >
    </nav>
  </header>
</template>

<script>
import NavDropdown from "./NavDropdown.vue";

export default {
  name: "NavBar",
  components: {
    NavDropdown,
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    toggleMenu(event) {
      event.stopPropagation();
      this.menuOpen = !this.menuOpen;
      const header = document.querySelector(".header");
      if (this.menuOpen) {
        header.classList.add("open");
        // Add listener on next tick to avoid immediate trigger
        this.$nextTick(() => {
          document.addEventListener("click", this.handleClickOutside);
        });
      } else {
        header.classList.remove("open");
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    closeMenu() {
      this.menuOpen = false;
      const header = document.querySelector(".header");
      header.classList.remove("open");
      document.removeEventListener("click", this.handleClickOutside);
    },
    handleClickOutside(event) {
      // Only handle click outside on mobile when menu is open
      if (window.innerWidth <= 768) {
        const header = this.$el;
        if (header && !header.contains(event.target)) {
          this.closeMenu();
        }
      }
    },
    handleNavClick() {
      // Close menu when clicking nav links on mobile
      if (window.innerWidth < 768) {
        this.closeMenu();
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 100%;
  padding: 1rem;

  background-color: var(--main-green);
  font-family: "Frank Ruhl Libre", serif;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  text-decoration: none;
  color: white;
  padding: 0.5rem;
}
.logo:hover {
  color: var(--main-accent);
  transform: scale(1.05);
}

.navbar {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.5rem;
}

.nav-link {
  text-decoration: none;
  color: white;
  padding: 0.5rem;
}
.nav-link:hover {
  color: var(--main-accent);
  transform: scale(1.05);
}

/* Hamburger hidden on desktop */
.hamburger {
  display: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: white;
  background: none;
  border: none;
}

/* Mobile / tablet */
@media (max-width: 768px) {
  .hamburger {
    display: block;
  }

  /* Center logo without absolute positioning */
  .header {
    position: sticky;
  }
  .logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .logo:hover {
    color: var(--main-accent);
    transform: translateX(-50%) scale(1.05);
  }

  /* Slide-down menu */
  .navbar {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;

    display: flex;
    flex-direction: column;
    align-items: center;

    background-color: var(--main-green);

    max-height: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;

    transition: max-height 250ms ease, opacity 200ms ease;
  }

  .header.open .navbar {
    max-height: 60vh;
    opacity: 1;
    pointer-events: auto;
    padding: 0.75rem 0;
  }

  .nav-link {
    width: 100%;
    text-align: center;
    padding: 0.25rem 0;
    font-size: 1.1rem;
  }
}
</style>
